// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"6e7330a8","54":"613a2a0a","166":"002c90ac","232":"02fbf3b0","260":"057f6caf","310":"2d4ee253","573":"6aaa27ac","730":"e21f94d4","838":"461a3ec9","851":"4c24fab3","890":"537c1a90","958":"6d7443e7","990":"c11a024d"}[chunkId] + ".chunk.js";
};